export default __webpack_public_path__ + "static/media/octahedron.9bd76b49.usdz";